// extracted by mini-css-extract-plugin
export default {"pageLayout":"Metals_pageLayout__o3CHd"};